import type { DefectCatalogItem } from '../contracts/availableLayers';
import { getPas2161CatalogDefects } from './pas2161Catalog';

export function mergePas2161CatalogDefects(
  defects: readonly DefectCatalogItem[],
  surveyTypes?: readonly string[],
): readonly DefectCatalogItem[] {
  const surveyTypeFilters = (surveyTypes ?? [])
    .map((value) => value.trim().toLowerCase())
    .filter(Boolean);

  const pas2161Defects =
    surveyTypeFilters.length === 0
      ? getPas2161CatalogDefects()
      : getPas2161CatalogDefects().filter((defect) =>
          surveyTypeFilters.includes(defect.surveyType.trim().toLowerCase()),
        );

  if (pas2161Defects.length === 0) {
    return defects;
  }

  const bySlug = new Map<string, DefectCatalogItem>();
  for (const defect of defects) {
    bySlug.set(String(defect.slug), defect);
  }
  for (const pas2161 of pas2161Defects) {
    bySlug.set(String(pas2161.slug), pas2161);
  }
  return Array.from(bySlug.values());
}
